module.exports = __webpack_public_path__ + "ced6e598c9097b8c7ca1e4bf8f8aacb4.jpg";